<template>
    <section class="testimonials" :style="'background:url(/static/img/world-map.png) #333'">
        <div class="container">
            <div class="section-title light wow fadeIn">
                <h2>What clients say about us</h2>
            </div>
            <!-- end section-title -->
            <div class="swiper-testimonials wow fadeIn">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="testimonial">

                            <blockquote>
                                <p>“Shamal’s 360° understanding of what makes the tourism industry tick combined with years of experience working in the tourism sector makes them the perfect business partner for Arabian Travel Market. Having worked with the team since 2010, I have witnessed first-hand their commitment to delivering an outstanding service and I have complete confidence in their ability to deliver a creative and focused strategic campaign year-on-year. Nothing is ever too much trouble, case in point being their fantastic onsite press office organisation and management, this has allowed ATM to build an excellent relationship with media and has ensured our key messages reach the right people every time.” </p>
                            </blockquote>
                            <small>Fiona Ashton,
                                <br>
                                <cite title="Marketing Manager, Arabian Travel Market">Marketing Manager, Arabian Travel Market, REED Exhibitions  </cite></small></div>
                        <!-- end testimonial -->
                    </div>
                    <!-- end swiper-slide -->

                    <div class="swiper-slide">
                        <div class="testimonial">

                            <blockquote>
                                <p>“As a homegrown hotel operator in a region where new properties and big names crowd the media agenda, ensuring that we position the TIME Hotels brand in the right way and clearly differentiate ourselves in the market has been our goal from day one. Shamal has been instrumental in driving this forward, and their strategic advisory capabilities are a valuable addition to our own in-house expertise.” </p>
                            </blockquote>
                            <small>Mohamed Awadalla, <br>
                                <cite title="CEO, TIME Hotels">CEO, TIME Hotels</cite>
                            </small></div>
                        <!-- end testimonial -->
                    </div>
                    <!-- end swiper-slide -->


                  <div class="swiper-slide">
                        <div class="testimonial">

                            <blockquote>
                                <p>“Shamal Communications have been integral to driving awareness and getting our voice heard when it comes to tackling industry issues within the facilities management arena. Working with the team at Shamal has given us the opportunity to take our message to different outlets and communicate with both our clients and end users through new channels. They have a fantastic understanding of the complexity and opportunities surrounding sustainability and technical innovation, which is integral to what we do as a company; and have helped us consolidate our position as a pioneer in this area.” </p>
                            </blockquote>
                            <small>Markus Oberlin, <br>
                                <cite title="CEO, Farnek">CEO, Farnek</cite>
                            </small></div>
                        <!-- end testimonial -->
                    </div>
                    <!-- end swiper-slide -->


                   <div class="swiper-slide">
                        <div class="testimonial">

                            <blockquote>
                                <p>“Congratulations in your successful journey and the new rebranding. Your success in the market is a reflection of the dedication and hard work that you have put in. I wish you years of success and we look forward to continue working with Shamal Communications.” </p>
                            </blockquote>
                            <small>Abdulla Bin Sulayem, <br>
                                <cite title="CEO, Seven Tides">CEO, Seven Tides</cite>
                            </small></div>
                        <!-- end testimonial -->
                    </div>
                    <!-- end swiper-slide -->



                   <div class="swiper-slide">
                        <div class="testimonial">

                            <blockquote>
                                <p>“We have been working with Shamal Communications for many years now. They have proven themselves, time and time again, to be consummate PR professionals bringing creativity, ideation and added value to our communications programs in the Middle East. Shamal Communications are a highly organized, structured, professional and well-connected PR agency in the region. They have good relationships with the media across a wide range of publications, both trade and business, and achieve outstanding levels of coverage for us each time we work together. Most importantly we have a great relationship with Shamal and they are a pleasure to work with.” </p>
                            </blockquote>
                            <small>Fiona D’Arcy, <br>
                                <cite title="CMO, Linesight ">CMO, Linesight </cite>
                            </small></div>
                        <!-- end testimonial -->
                    </div>
                    <!-- end swiper-slide -->



                   <div class="swiper-slide">
                        <div class="testimonial">

                            <blockquote>
                                <p>“The region’s real estate market is an industry sector that has commanded plenty of attention over the last decade. The Shamal team has been, and continues to be, our key strategic partner with a thorough understanding of our business and corporate culture linked to unmatched capabilities in terms of communicating our expertise and asserting our position as a market leader in the UAE through their large network of media contacts in key industry sectors.” </p>
                            </blockquote>
                            <small>John Stevens, <br>
                                <cite title="Managing Director, Asteco ">Managing Director, Asteco </cite>
                            </small></div>
                        <!-- end testimonial -->
                    </div>
                    <!-- end swiper-slide -->
                   <div class="swiper-slide">
                        <div class="testimonial">

                            <blockquote>
                                <p>“Shamal Communications was appointed as the agency to assist Katara Hospitality with specific PR services during the launch process. It proved to be a fortunate choice, as we found Shamal not only a reliable PR agency, but also a valuable advisor and a trusted partner that stood by our side through the duration of the project and beyond, having had a major contribution to the overall success of the event.” </p>
                            </blockquote>
                            <small>Tamara Khalil, <br>
                                <cite title="Corporate Director - Marketing and Communications at Katara Hospitality ">Corporate Director - Marketing and Communications at Katara Hospitality </cite>
                            </small></div>
                        <!-- end testimonial -->
                    </div>
                    <!-- end swiper-slide -->

                </div>
                <!-- end swiper-wrapper -->
                <div class="swiper-button-next"><img :src="'/static/img/icon-right-arrow.svg'" alt="Image"></div>
                <div class="swiper-button-prev"><img :src="'/static/img/icon-right-arrow.svg'" alt="Image"></div>
            </div>
            <!-- end swiper-testimonials -->
        </div>
        <!-- end container -->
    </section>

</template>
<script>
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.min.css';

    export default {
        props: [],
        mounted() {
            // TESTIMONIALS
            var swiper = new Swiper('.swiper-testimonials', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            });

        }
    }
</script>
<style lang="scss">

    /* TESTIMONIALS */
    .testimonials {
        margin: 1px 0;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 100px 0;
        background: #333;
        /*background: url(../images/world-map.png) center no-repeat blue;*/
        text-align: center;
        color: #fff;
        background-size: auto 80%;

        .section-title {
            margin-bottom: 40px;
        }

        .swiper-testimonials {
            width: 100%;
            float: left;
            position: relative;
            overflow: hidden;

            .swiper-button-prev {
                background: none;
                width: 50px;
                height: auto;
                -webkit-filter: brightness(0) invert(1);
                filter: brightness(0) invert(1);
                transform: rotate(180deg);

                &:hover {
                    opacity: 0.5;
                }
            }

            .swiper-button-next {
                background: none;
                width: 50px;
                height: auto;
                -webkit-filter: brightness(0) invert(1);
                filter: brightness(0) invert(1);

                &:hover {
                    opacity: 0.5;
                }
            }
        }

        .testimonial {
            width: 100%;
            flex: 1;
            padding: 0 12%;

            figure {
                display: block;
                position: relative;
                margin-bottom: 30px;

                .avatar {
                    width: 80px;
                    border-radius: 50%;
                }

                figcaption {
                    width: 30px;
                    height: 30px;
                    background: orange;
                    border-radius: 50%;
                    position: absolute;
                    left: 50%;
                    bottom: -15px;
                    margin-left: -15px;

                    img {
                        width: 15px;
                        margin: 8px;
                    }
                }
            }

            blockquote {
                display: block;
                margin:10px 0  30px;
                border: none;
                font-weight: normal;


                p {
                    font-size: 22px;
                    line-height: 32px;
                    font-weight: normal;
                    color: #fff;
                    margin: 0;
                    letter-spacing: 1px;
                }
            }

            small {
                display: block;
                margin: 10px 0;
                color: #ddd;
                font-size: 15px;
                opacity: 0.7;
                font-style: italic;
            }

            .name-sign {
                height: 40px;
            }

            .logo {
                height: 50px;
                -webkit-filter: brightness(1) invert(1);
                filter: brightness(1) invert(1);
            }
        }
    }


    @media (max-width:768px) {
      h2 {
        font-size: 1.6rem;
      }
      .testimonials .testimonial {
        padding: 0;
      }
       .testimonials .testimonial blockquote p {
        font-size: 12px;
         line-height: 1.4;
      }
    }

</style>